export default "__VITE_ASSET__RU1JNcAz__"